import { Capacitor } from '@capacitor/core';
export const isMobileApp = Capacitor && (Capacitor.platform === 'android' || Capacitor.platform === 'ios');
